import glossary from './glossary.js';
import { getBrowserLanguage } from './language.js';

const defaultLang = 'en';
const defaultError = glossary.default?.[defaultLang];

export default function getErrorMessage(errorCode) {
    const lang = getBrowserLanguage();

    return glossary[errorCode]?.[lang] || glossary[errorCode]?.[defaultLang] || glossary.default?.[lang] || defaultError;

}
